export function getUserData() {
    const userData = localStorage.getItem('userData')
    return userData ? JSON.parse(userData) : null
}

// TODO: check
export const $roles = {
    monitors: [
        'order.list',
        'order-department.list',
        'ticket-time.edit',
        'monitoring.list',
        'foreman.list',
    ],
}

export function getHomeRouteForLoggedInUser() {
    const data = getUserData()
    const permissions = data?.permissions || []
    const getRedirectPage = userPermissions => {
        if (userPermissions.includes('ticket-time.edit')) return 'ticket-time'
        if (userPermissions.includes('foreman.list')) return 'foreman'
        if (userPermissions.includes('order-department.list'))
            return 'orders-department'
        return 'order-list'
    }
    return { name: getRedirectPage(permissions) }
}

export function getFirstDivisionInfo() {
    const data = getUserData()
    const divisions = data?.user?.divisions || data?.divisions || []
    const firstDivision = divisions[0]

    return {
        id: firstDivision?.id || null,
        name: firstDivision?.name || '',
    }
}
